<template lang="pug">
    #imageLink
        ul
            li
                a(:href="contents.content.link")
                    .img
                        img(:src="image").image
</template>

<script>
import { props } from '@/mixins/component';

export default {
    name: "component-image-link",
    props,
    computed: {
        image() {
            return this.contents.content.image
        }
    }
    
}
</script>

<style lang="stylus" scoped src="./ImageLink.styl"></style>
